import React from "react";

// Shared legal-page layout — kept minimal to match the editorial site style.
export default function LegalPage({ eyebrow, title, updated, sections = [], testId }) {
  return (
    <div data-testid={testId}>
      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pt-36 md:pt-48 pb-12 md:pb-16">
        <p className="text-xs uppercase tracking-label text-accent mb-6">{eyebrow}</p>
        <h1 className="font-display font-light leading-[1.0] text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] tracking-tight max-w-4xl">
          {title}
        </h1>
        {updated && (
          <p className="mt-6 text-xs uppercase tracking-label text-muted-foreground">Senest opdateret: {updated}</p>
        )}
      </section>

      <section className="mx-auto max-w-3xl px-6 md:px-12 pb-32 md:pb-40 space-y-14 font-light">
        {sections.map((s, i) => (
          <div key={i}>
            {s.heading && (
              <h2 className="font-display text-2xl md:text-3xl font-light mb-4 text-balance">
                {s.number ? <span className="text-muted-foreground/60 mr-3">{s.number}</span> : null}
                {s.heading}
              </h2>
            )}
            {s.body && (
              <div className="text-foreground/80 leading-relaxed space-y-4">
                {s.body.split("\n\n").map((p, j) => (
                  <p key={j} className="whitespace-pre-line">{p}</p>
                ))}
              </div>
            )}
            {s.list && (
              <ul className="mt-4 space-y-2 text-foreground/80 list-none">
                {s.list.map((item, j) => (
                  <li key={j} className="pl-4 relative">
                    <span className="absolute left-0 top-[0.75em] w-1.5 h-1.5 bg-accent rounded-full"></span>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </section>
    </div>
  );
}
